import {
  Box,
  ListItem,
  SimpleGrid,
  Text,
  UnorderedList
} from "@chakra-ui/react";
import LineSection from "../lineSection"
import Lang from "../../Lang";

export default function Background() {
  return (
    <>
      <LineSection />

      <Box
        color='white'
        pb={20}
      >

        <center>
          <Box
            w={{ base: "full", md: "3xl", xl: "7xl" }}
            pt={20}
          >

            <SimpleGrid
              columns={{ base: 1, md: 1, xl: 2 }}
            >

              <Box
                m={5}
              >
                <Text
                  fontSize={{ base: "3em", md: "6em", xl: "7em" }}
                  className="barlow-black"
                  align={"left"}
                >
                  <Lang text="What is the problem to be solved?" />
                </Text>
              </Box>

              <Box
                m={5}
                align={"left"}
              >
                <UnorderedList
                  fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7em", xl: "2em" }}
                >
                  <ListItem mb={5}>
                    <Lang text="Young people want to learn how to code and create new technologies but do not have the funds to achieve it." />
                  </ListItem>
                  <ListItem mb={5}>
                    <Lang text="There are isolated communities with young people eager to learn about technologies but do not have access to this sort of education." />
                  </ListItem>
                  <ListItem mb={5}>
                    <Lang text="There are local social leaders with technology education initiatives for young people, but they do not have enough resources to develop these projects successfully." />
                  </ListItem>
                  <ListItem mb={5}>
                    <Lang text="Low-income countries have a low rate of training in new technologies, which makes them not competitive in the world market." />
                  </ListItem>
                </UnorderedList>
              </Box>

            </SimpleGrid>
          </Box>
        </center>

      </Box>
    </>

  );
}